import { ClientService, ToastMessageService } from '@fitness-force/api';
import { Store } from '@ngrx/store';
import { AsyncPipe } from '@angular/common';
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  input,
  output,
  inject,
} from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { DialogModule } from 'primeng/dialog';
import { StyleClassModule } from 'primeng/styleclass';
import { BehaviorSubject } from 'rxjs';
import { TENANTS_INFO } from '@fitness-force/state';
import type { TENANTSINTERFACE } from '@fitness-force/models';
import { DateFormatedComponent } from '@fitness-force/grid-utility';
import { TenantNameComponent } from '../../data-grid/utility/tenant/tenant-name/tenant-name.component';
import { StaffInfoComponent } from '../../staff/staff-info/staff-info.component';
import { DataGridComponent } from '@fitness-force/grid';
import { EmptyStateContainerComponent } from '@fitness-force/grid';
@Component({
  selector: 'client-history',
  templateUrl: './client-history.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    DialogModule,
    StyleClassModule,
    TranslateModule,
    DataGridComponent,
    AsyncPipe,
  ],
})
export class ClientHistoryComponent implements OnInit {
  private store = inject(Store);
  translate = inject(TranslateService);
  private clientService = inject(ClientService);
  toastMessageService = inject(ToastMessageService);
  private cd = inject(ChangeDetectorRef);

  readonly clientHistoryModal = input<boolean | null>(false);
  readonly clientData$ = input(new BehaviorSubject<any>(null));
  readonly closeClientHistoryDialog = output<boolean>({
    alias: 'closeClientHistoryDialog',
  });
  allClientData$ = new BehaviorSubject<any>({});
  clientData: any;
  allTenants$ = new BehaviorSubject<any>([]);
  isloading: boolean = false;
  tenantId: number = 0;
  claims: string[] = ['can_be_client_rep'];
  tableData = new BehaviorSubject<any[]>([]);
  tableColumns = new BehaviorSubject<any[]>([]);
  emptyStateComponent = new BehaviorSubject<any>(EmptyStateContainerComponent);

  ngOnInit(): void {
    this.componentInit();
  }

  componentInit() {
    const clientDataSubject = this.clientData$();
    if (clientDataSubject) {
      clientDataSubject.subscribe((client: any) => {
        this.allClientData$.next(client);
        this.clientData = client;
        this.store
          .select(TENANTS_INFO)
          .subscribe((tenant: TENANTSINTERFACE) => {
            this.tenantId = tenant.selected_tenant.id;
            this.allTenants$.next(tenant.accessed_tenant);
            this.getClientHistory();
          });
      });
    }
  }

  getClientHistory() {
    this.isloading = true;
    this.clientService.getClientHistory(this.clientData.id).subscribe({
      next: (res: any) => {
        this.tableData.next(res.items);
        this.columnTranslate();
        this.isloading = false;
      },
      error: (error: any) => {
        this.tableData.next([]);
        this.columnTranslate();
        this.isloading = false;
      },
      complete: () => {
        this.isloading = false;
        this.cd.detectChanges();
      },
    });
  }

  columnTranslate() {
    this.translate
      .get([
        'Shared.PROSPECT.MORE_FILTERS.DATE',
        'REFUND.TENANT',
        'Shared.PROSPECT.MORE_FILTERS.CHANNEL',
        'Shared.PROSPECT.MORE_FILTERS.SOURCE',
        'CreateEditStaff.SPAN_STAFF',
        'TRANSFER.COMMENTS',
      ])
      .subscribe((translations) => {
        this.setColumnTranslate(translations);
      });
  }

  setColumnTranslate(translations: any) {
    var column = {
      DateTime: translations['Shared.PROSPECT.MORE_FILTERS.DATE'],
      Tenant: translations['REFUND.TENANT'],
      Channel: translations['Shared.PROSPECT.MORE_FILTERS.CHANNEL'],
      Source: translations['Shared.PROSPECT.MORE_FILTERS.SOURCE'],
      Staff: translations['CreateEditStaff.SPAN_STAFF'],
      Comments: translations['TRANSFER.COMMENTS'],
    };
    this.tableColumns.next([
      {
        title: column.DateTime,
        classes: 'py-3 white-space-nowrap align-items-center uppercase',
        dataProperty: 'prospect_effective_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: {
            KeyName: 'prospect_effective_date',
            format: 'datetime',
            applytimezone: true,
          },
        },
      },
      {
        title: column.Tenant,
        classes: 'py-3 white-space-nowrap uppercase',
        dataProperty: 'tenant_id',
        type: 'component',
        data: {
          name: TenantNameComponent,
          additionData: true,
          aData: { fetch_key: 'tenant_id' },
        },
      },
      {
        title: column.Channel,
        classes: 'py-3 white-space-nowrap uppercase',
        dataProperty: 'channel',
        type: 'default',
      },
      {
        title: column.Source,
        classes: 'py-3 white-space-nowrap uppercase',
        sortable: false,
        filterable: true,
        dataProperty: 'source',
        type: 'default',
      },
      {
        title: column.Staff,
        classes: 'py-3 white-space-nowrap uppercase',
        dataProperty: 'created_by',
        type: 'component',
        data: { name: StaffInfoComponent },
      },
    ]);
  }

  closeDialogEvent() {
    this.closeClientHistoryDialog.emit(true);
    this.closeClientHistoryDialog.emit(true);
  }
}
